// src/lib/kinema/konva/overlays/MarqueeOverlay.ts
import Konva from 'konva';
import type { Rect } from '../../core/tools/types';

export class MarqueeOverlay {
  private rect: Konva.Rect | null = null;
  private layer: Konva.Layer;

  constructor(layer: Konva.Layer) {
    this.layer = layer;
  }

  showMarquee(rect: Rect): void {
    if (!this.rect) {
      this.rect = new Konva.Rect({
        stroke: '#2563eb',
        strokeWidth: 1,
        dash: [4, 4],
        fill: 'rgba(37,99,235,0.1)',
        listening: false,
      });
      this.layer.add(this.rect);
    }
    this.rect.setAttrs({ x: rect.x, y: rect.y, width: rect.width, height: rect.height });
    this.layer.batchDraw();
  }

  clear(): void {
    this.rect?.destroy();
    this.rect = null;
    this.layer.batchDraw();
  }
}
